var Menu = {

	isMobile:true,

	init:function(){

		$(window).resize(function(){
			Menu.resize();
		});

		Menu.resize();
	},
	unbind_events:function(){
		/**
		*    HEADER 
		**/
		$(".header .left").find(".menu-item").off("click touchend");
		$(".header .menu-mobile").find(".btn-close").off("click touchend");
		$(".header .menu-item a, .header .menu-item span").off("click touchend mouseenter mouseleave");
		$(".header .menu-item .picto.prev").off("click touchend");
		/**
		*    DESKTOP 
		**/
		$(".header .nav-main > .susy-container > .menu-container > .menu-item").off("mouseenter mouseleave");
	},

	bind_desktop:function(){

		$(".header .nav-main > .susy-container > .menu-container > .menu-item").on("mouseenter", function(){
			Menu.open_menu_desktop($(this));
		}).on("mouseleave", function(){
			Menu.close_menu_desktop($(this));
		});	
	},
	open_menu_desktop:function(pTarget){
		$(".header").addClass("open");
		$(".header .nav-main > .susy-container > .menu-container > .menu-item").removeClass("open");
		pTarget.addClass("open");
		var _h_bg = pTarget.find(" > .menu-container").outerHeight();
		Menu.move_background(_h_bg);
	},
	close_menu_desktop:function(){
		$(".header").removeClass("open");
		$(".header .nav-main > .susy-container > .menu-container > .menu-item").removeClass("open");
		Menu.move_background(0);
	},
	move_background:function(pSize){
		$(".header .bg-menu-desktop").css({height:pSize});
	},

	bind_mobile:function(){
		$(".header .left").find(".menu-item").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}

			$("html").toggleClass("menu-open");
			$("body").toggleClass("no-scroll");
			$(".header").toggleClass("open");

		});
		
		$(".header .menu-mobile").find(".btn-close").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}

			$("html").toggleClass("menu-open");
			$("body").toggleClass("no-scroll");
			$(".header").toggleClass("open");

		});

		$(".header .menu-item a, .header .menu-item span").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}

			e.preventDefault();
			e.stopImmediatePropagation();

			if($(this).parent().hasClass("menu-item-has-children")){
				if($(this).parent().hasClass("open")){

					if($(this).attr("href")){
						Menu.open_link($(this).attr("href"));
					}

				}else{
					Menu.open_menu_mobile($(this).parent());
				}
			}else{
				if($(this).attr("href")){
					Menu.open_link($(this).attr("href"));
				}
			}




		});

		$(".header .menu-item .picto.prev").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}

			e.preventDefault();
			e.stopImmediatePropagation();

			Menu.close_menu_mobile($(this).parent().parent().parent());

		});
	},

	open_link:function(pValue){
		window.location.href = pValue;
	},
	open_menu_mobile:function(pTarget){
		pTarget.parent().find(" > .menu-item").removeClass("open").addClass("closed");
		pTarget.removeClass("closed").addClass("open");

		pTarget.parent().parent().find("> a, > span").addClass("prev");
	},
	close_menu_mobile:function(pTarget){
		pTarget.find(" .menu-item").removeClass("open closed");
		pTarget.find(" .menu-item > a, .menu-item > span").removeClass("prev");
	},


	resize:function(){
		Menu.unbind_events();
		Menu.close_menu_desktop();

		$("html").removeClass("menu-open");
		$("body").removeClass("no-scroll");
		$(".header").removeClass("open");

		if($(".header .mobile").css("display") == "block"){
			Menu.isMobile = true;
			Menu.bind_mobile();
		}else{
			Menu.isMobile = false;
			
			/*Menu.bind_desktop();*/
		}
	}
}
